import { render } from "./InvoicesIndex.vue?vue&type=template&id=11396509"
import script from "./InvoicesIndex.vue?vue&type=script&lang=js"
export * from "./InvoicesIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__